import { createApp } from 'vue'
import AppRoot from './AppRoot.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { authInterceptor } from '@/data/fetchinterceptor'
import { PassiveEvents } from './plugins/passive-events'

// 解决 ResizeObserver 错误 - Tab切换时常见警告
// 这个错误不会影响功能，只是控制台警告
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    event.preventDefault(); // 阻止错误显示到控制台
    return false;
  }
});

authInterceptor.start()

const app = createApp(AppRoot)
const piniaapp = createPinia()
piniaapp.use(piniaPluginPersistedstate)
app.use(PassiveEvents)
app.use(router)
app.use(piniaapp)
app.use(ElementPlus, { locale: zhCn })
app.mount('#app')
